import React, { useEffect, useMemo, useState } from "react";
import AvatarUsername from "./AvatarUsername";
import StarRating from "./StarRating";
import {
	Button,
	Col,
	Image,
	Modal,
	Row,
	Skeleton,
	Typography,
	message,
} from "antd";
import Timestamp from "./Timestamp";
import Description from "./Description";
import CommentSwiper from "../commentSwiper/CommentSwiper";
import { CommentJson, TypeList } from "features/comment/types/comment.type";
import Reaction from "./Reaction";
import CommentList from "../list/CommentList";
import CommentForm from "./../commentForm.tsx/CommentForm";
import { useDeleteCommentMutation } from "features/comment/service/comment.service";
import { useAppDispatch, useAppSelector } from "app/hooks";
import FileModel from "common/models/FileModel";
import { FileJson } from "common/types/File";
import { setModel } from "features/comment/CommentSlice";
import ReviewDetail from "../commentDetail/ReviewDetail";
import { selectToken } from "features/auth/AuthSlice";
import { ReviewDetailList } from "../commentDetail/ReviewDetail";
import CommentIcon from "library/icons/comment/CommentIcon";
type Props = {
	data: CommentJson;
	isLoading: boolean;
	style?: React.CSSProperties | undefined;
	type_list: TypeList;
	item_type: string;
	item_id: string;
	parent_user?: string;
};

const CommentItem: React.FC<Props> = ({
	style = { width: "100%" },
	isLoading,
	data,
	type_list,
	item_type,
	item_id,
	parent_user,
}) => {
	const [messageApi, contextHolder] = message.useMessage();

	//
	const [showForm, setShowForm] = useState(false);
	const [showComment, setShowComment] = useState(false);

	const [visible, setVisible] = useState<string>("");
	const [idEdit, setIdEdit] = useState<number>(0);
	const [showReviewDetail, setShowReviewDetail] = useState<CommentJson[]>([]);
	const [defaultIndexSlide, setDefaultIndexSlide] = useState(0);
	const [confirmDeleteId, setConfirmDeleteId] = useState(0);
	const [loadingDelete, setLoadingDelete] = useState(false);
	//
	const currentUser = useAppSelector((state) => state.auth.user);
	const token = useAppSelector(selectToken);
	const listReview = useAppSelector((state) => state.comment.listReview);
	const listComment = useAppSelector((state) => state.comment.listComment);
	// const urlAsset = useAppSelector(selectUrlAsset);
	const dispatch = useAppDispatch();
	//

	const [
		deleteComment,
		{ isLoading: deleteLoading, isError, isSuccess: deleteSuccess },
	] = useDeleteCommentMutation();

	// varible process
	const typeText = useMemo((): string => {
		let text = "";

		switch (type_list) {
			case "comment":
				text = "bình luận";
				break;
			case "review":
				text = "đánh giá";
				break;
			default:
				text = "câu hỏi";
				break;
		}
		return text;
	}, [type_list]);
	const isEditNonUser: boolean = useMemo(() => {
		const list =
			type_list === "review"
				? listReview
				: type_list === "comment"
				? listComment
				: [];
		const is_exit =
			list.length > 0 ? list.some((i) => i.id === data.id) : false;

		return is_exit;
	}, [typeText, listReview, listComment]);

	const listchildComment = useMemo(() => {
		return listComment.filter((i) => i.parent_id === data.id);
	}, [listComment, listReview]);

	const opacity = data.status !== 1 ? "30%" : "1";
	/////////////////////////////////
	// function
	const handleSuccessForm = (type: string) => {
		let Text = "";
		switch (type) {
			case "comment":
				Text = "bình luận";
				break;
			case "review":
				Text = "đánh giá";
				break;
			default:
				Text = "câu hỏi";
				break;
		}
		messageApi.open({
			content: `Cảm ơn bạn đã để lại ${Text} !`,
			duration: 4,
			type: "success",
		});
		// type_list !== "comment" && setShowForm((prev) => !prev);
	};

	const handleSuccessFormEdit = () => {
		messageApi.open({
			content: `Sửa ${typeText} thành công !`,
			duration: 4,
			type: "success",
		});
		setIdEdit(0);
	};

	const handleShowListChildren = (item_id: string) => {
		setVisible((prev) => {
			if (prev === "") {
				return JSON.stringify(data.id);
			} else {
				return "";
			}
		});
		setShowComment((prev) => !prev);
	};

	const handleDeleteComment = async (id: number) => {
		setLoadingDelete(true);
		try {
			const res = await deleteComment({ id }).unwrap();
			if (res) {
				setConfirmDeleteId(0);
				messageApi.open({
					content: `Xóa ${typeText} thành công !`,
					duration: 4,
					type: "success",
				});
			}
		} catch (error) {
			messageApi.open({
				content: `Có lỗi không thể xóa !`,
				duration: 4,
				type: "error",
			});
		}
		setLoadingDelete(false);
	};

	const handleEditComment = (data: CommentJson) => {
		setVisible("");
		setIdEdit(data.id);
		dispatch(setModel(data));
	};

	//////////////////////////////////
	const dataReviewDetailActive: ReviewDetailList[] = useMemo(() => {
		let newData: ReviewDetailList[] = [];
		const review_list = new Array(data).filter(
			(review) => review.images.length > 0
		);
		if (review_list.length >= 7) {
			review_list.forEach((item, index) => {
				newData.push({ activeImage: index, ...item });
			});
		} else {
			review_list.forEach((item) => {
				item.images.forEach((img, index) => {
					newData.push({ activeImage: index, ...item });
				});
			});
		}
		return newData;
	}, [data]);
	/////////////////////////////////
	//style
	const styles = {
		avatarUser: {
			opacity: opacity,
		},
		skeleton: {
			padding: "0 0 24px 0",
			opacity: opacity,
		},
		starRating: {
			// margin: "12px 0 13px 0",
			opacity: opacity,
		},
		description: {
			// margin: "12px 0 0 0",
			opacity: opacity,
		},
		swipe: {
			// margin: "16px 0 0",
			opacity: opacity,
		},
		reaction: {},
		button: {
			fontSize: "12px",
			color: "#898889",
			border: "none",
			boxShadow: "none",
			padding: 0,
			outline: "none",
			display: "flex",
			justifyContent: "start",
			alignItems: "center",
			gap: "5.67px",
			cursor: "pointer",
			margin: 0,
			height: "12px",
		},
		border: {
			borderRight: "1px solid #898889",
			height: "10px",
			margin: 0,
		},
	};
	const Span = ({ className = "" }: { className?: string }) => {
		return (
			<Col
				id="action_span_wrapper "
				className={`${className}`}
				style={{ display: "flex", justifyContent: "center" }}>
				<span
					className="action_span"
					style={{
						width: "12px",
						border: "1px solid #E6E7E8",
						transform: "rotate(90deg)",
					}}></span>
			</Col>
		);
	};
	const action = [
		{
			index: 1,
			is_show: data.status !== 0 && data.status !== 2,
			children: (
				<>
					<Col>
						<Reaction likeCount={data.like} isLiked={false} id={data.id} />
					</Col>
				</>
			),
		},

		{
			index: 3,
			is_show:
				data.status !== 1 &&
				data.status !== 0 &&
				currentUser &&
				currentUser.company.customer.id === data.customer_id,
			children: (
				<>
					{data.status !== 0 && data.status !== 2 && <Span></Span>}
					<Col>
						<Button
							type="default"
							onClick={() => {
								handleEditComment(data);
							}}
							loading={false}
							disabled={false}
							style={{
								...styles.button,
								border: "none",
								backgroundColor: "transparent",
								boxShadow: "none",
								lineHeight: "100%",
							}}>
							<div
								className="comment_icon"
								id="comment_icon-edit"
								style={{ width: 24, height: 24 }}></div>
							Sửa
						</Button>
					</Col>
				</>
			),
		},
		{
			index: 2,
			is_show:
				currentUser &&
				currentUser.company.customer.id === data.customer_id &&
				data.status !== 1,

			children: (
				<>
					<Span></Span>
					<Col>
						<Button
							type="default"
							onClick={() => {
								// handleDeleteComment(data.id, 0);
								setConfirmDeleteId(data.id);
							}}
							loading={deleteLoading}
							disabled={deleteLoading}
							style={{
								...styles.button,
								border: "none",
								backgroundColor: "transparent",
								boxShadow: "none",
								lineHeight: "100%",
							}}>
							<div
								id="comment_icon-delete"
								className="comment_icon"
								style={{ width: 24, height: 24 }}></div>
							Xóa
						</Button>
					</Col>
				</>
			),
		},
		{
			index: 4,
			is_show:
				type_list !== "comment" &&
				(data.status !== 0 ||
					(currentUser &&
						currentUser.company.customer.id !== data.customer_id &&
						data.status !== 0)),
			children: (
				<>
					<Span></Span>
					<Col>
						<p
							style={{
								...styles.button,
							}}
							onClick={() => handleShowListChildren(JSON.stringify(data.id))}>
							{/* <div
                className="comment_icon"
                id="comment_icon-message"
                style={{ width: 24, height: 24 }}
              ></div> */}
							<CommentIcon></CommentIcon>
							{/* <img
                src={urlAsset + "/comment-message_icon.png"}
                alt="message-icon"
              /> */}
							{`Bình luận (${data.count_chill})`}
						</p>
					</Col>
				</>
			),
		},
		{
			index: 5,
			is_show: data.status !== 1,
			children: (
				<>
					{data.status !== 0 && <Span className="span_last"></Span>}
					<Col>
						<p
							style={{
								...styles.button,
								color: "#D72229",
							}}>
							{typeText.charAt(0).toUpperCase() + typeText.slice(1)} của bạn
							đang chờ duyệt
						</p>
					</Col>
				</>
			),
		},
	];

	////////////////////////////////
	useEffect(() => {
		if (process.env.NODE_ENV === "development") {
			console.error = function () {};
		}
	}, []);

	const RenderAction = ({ children }: { children: React.ReactNode }) => {
		return <React.Fragment>{children}</React.Fragment>;
	};

	return (
		<div style={{ ...style, display: "inline-block" }}>
			{contextHolder}
			{isLoading ? (
				<Row>
					<Col span={24}>
						<Skeleton
							avatar
							active
							paragraph={{ rows: 3 }}
							style={{ ...styles.skeleton }}
						/>
					</Col>
				</Row>
			) : (
				<Row gutter={[8, 8]} style={{ position: "relative" }}>
					<Col span={24}>
						<AvatarUsername
							style={{ ...styles.avatarUser }}
							username={data.name !== "" ? data.name : "user"}
							isLoading={isLoading}
						/>
					</Col>
					{type_list !== "comment" && (
						<Col span={24}>
							<StarRating
								isLoading={isLoading}
								style={{ ...styles.starRating }}
								stars={data.rate}
								titleRate={data.title}
							/>
						</Col>
					)}
					<Col span={24}>
						<Timestamp
							style={{ fontSize: "12px", color: "#898889" }}
							isLoading={isLoading}
							date_created={data.date_created}
						/>
					</Col>
					<Col span={24}>
						<Description
							style={{ ...styles.description }}
							isLoading={isLoading}
							content={data.detail}
							parent_user={parent_user}
							type_list={type_list}
							is_shadow_text={false}
							className="comment_item_description"
						/>
					</Col>
					{data?.images?.length > 0 && (
						<Col span={24}>
							<CommentSwiper
								idSwiper="image_item"
								initialSlide={0}
								dataSource={data ? data.images : []}
								isloading={isLoading}
								navigation={false}
								// styleWrapper={{ marginBottom: "200px" }}
								widthAutoSlide={true}
								styleWrapper={{ ...styles.swipe }}
								itemRender={(item: FileJson, index) => (
									<Image
										onClick={() => {
											if (data.status !== 0) {
												setShowReviewDetail(dataReviewDetailActive);
												setDefaultIndexSlide(index);
											}
										}}
										src={FileModel.getThumbnailFromUrl(
											item.file_path,
											1080,
											756,
											"crop"
										)}
										alt={`image_${item.title}`}
										width={85}
										height={85}
										style={{
											borderRadius: "8px",
											objectFit: "cover",
											width: "85px",
											height: "85px",
											cursor: "pointer",
										}}
										loading="lazy"
										preview={false}
										fallback="data:image/png;base64,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"></Image>
								)}
								autoplay={false}
								responsive={{
									xxs: { slidesPerView: 2.1, spaceBetween: 8 },
									xs: { slidesPerView: 2, spaceBetween: 8 },
									sm: { slidesPerView: 2, spaceBetween: 8 },
									md: { slidesPerView: 3, spaceBetween: 8 },
									lg: { slidesPerView: 4, spaceBetween: 8 },
									xl: { slidesPerView: 6, spaceBetween: 8 },
								}}></CommentSwiper>
						</Col>
					)}
					{/* Action */}

					<Col span={24} style={{ padding: 0, marginTop: 8 }}>
						<Row
							id="action_wrapper"
							align={"middle"}
							justify={"start"}
							style={{ margin: "0 0 0 4px", columnGap: 12, rowGap: 12 }}>
							{action
								.filter((col) => col.is_show === true)
								.map((col, index) => (
									<RenderAction key={index}>{col.children}</RenderAction>
								))}
						</Row>
					</Col>

					{data.status !== 0 && showComment && (
						<>
							<Col
								id="notifi_comment_item"
								md={{
									offset: type_list === "review" ? 2 : 0,
									span: type_list === "review" ? 22 : 24,
								}}
								xs={{
									offset: 0,
									span: 24,
								}}
								style={{
									display: "flex",
									justifyContent: "start",
									alignItems: "center",
									marginTop: 8,
									cursor: "pointer",
								}}
								onClick={() => {
									setShowForm((prev) => !prev);
								}}>
								<div
									id="comment_icon-arrow"
									className="comment_icon"
									style={{ width: 24, height: 24 }}></div>
								<span style={{ margin: 0, color: "#898889", fontSize: "12px" }}>
									Viết phản hồi cho {data.name}
								</span>
							</Col>
							{showForm && (
								<Col
									md={{
										offset: type_list === "review" ? 2 : 0,
										span: type_list === "review" ? 22 : 24,
									}}
									lg={{
										offset: type_list === "review" ? 2 : 0,
										span: 12,
									}}
									xs={{
										offset: type_list === "review" ? 0 : 0,
										span: type_list === "review" ? 24 : 24,
									}}>
									<CommentForm
										idForm="form_comment_wrapper"
										item_id={data.item_id}
										parent_id={data.id}
										item_type={item_type}
										handleSuccess={handleSuccessForm}
										handleCancelModal={() => {
											setShowForm(false);
											setVisible("");
										}}
										form_type="comment"></CommentForm>
								</Col>
							)}
							{/* {(data.has_child > 0 || listchildComment.length > 0) && (
                <Col
                  onClick={() => {
                    setVisible((prev) => {
                      if (prev === "") {
                        return JSON.stringify(data.id);
                      } else {
                        return "";
                      }
                    });
                  }}
                  xs={{
                    offset: 1,
                    span: 8,
                  }}
                  sm={{
                    offset: 2,
                    span: 8,
                  }}
                  md={{
                    offset: 2,
                    span: 8,
                  }}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    paddingLeft: 0,
                    cursor: "pointer",
                    marginTop: 8,
                  }}
                >
                  <div
                    id="comment_icon-arrow"
                    className="comment_icon"
                    style={{ width: 24, height: 24 }}
                  ></div>
                  <span
                    style={{ margin: 0, color: "#898889", fontSize: "12px" }}
                  >
                    {visible !== "" ? "Đóng" : " Xem bình luận"}
                  </span>
                </Col>
              )} */}
							{data.status !== 0 && visible !== "" && (
								<Col
									// offset={type_list === "review" ? { sm } : 0}
									md={{
										offset: type_list === "review" ? 2 : 0,
										span: type_list === "review" ? 22 : 24,
									}}
									xs={{
										offset: type_list === "review" ? 1 : 0,
										span: type_list === "review" ? 23 : 24,
									}}
									style={{ marginTop: 8 }}>
									<CommentList
										heightOverFlow={"auto"}
										borderOverFlow={false}
										hiddenScrollBar={true}
										id={visible}
										type_list="comment"
										item_type={item_type}
										item_id={data.item_id}
										parent_user={data.name}></CommentList>
								</Col>
							)}
						</>
					)}
				</Row>
			)}
			<Modal
				key={"form_edit"}
				open={idEdit > 0}
				title={
					<Typography.Title level={4} style={{ margin: "0 0 16px 0" }}>
						Sửa {typeText} {type_list === "review" && "sản phẩm"}
					</Typography.Title>
				}
				centered
				onCancel={() => {
					setIdEdit(0);
					dispatch(setModel(null));
				}}
				className={`modal_review`}
				wrapClassName="modal-review-wrapper"
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				bodyStyle={{ padding: "0" }}
				destroyOnClose={true}
				rootClassName="scrollableDiv_review"
				zIndex={1002}
				forceRender={false}
				footer={null}
				transitionName="custom-transition">
				<CommentForm
					item_id={data.item_id}
					parent_id={data.parent_id}
					item_type={item_type}
					handleSuccess={handleSuccessFormEdit}
					handleCancelModal={() => {
						setIdEdit(0);
						dispatch(setModel(null));
					}}
					form_type={type_list}
					idEditing={idEdit}></CommentForm>
			</Modal>
			<Modal
				wrapClassName="review-detail-modal modal-review-wrapper"
				className={`modal_review modal_reviewDetail`}
				key={"reviewDetail"}
				closable={true}
				open={showReviewDetail.length > 0 ? true : false}
				cancelText={"Đóng"}
				onCancel={() => {
					setShowReviewDetail([]);
				}}
				centered
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				width={"881px"}
				destroyOnClose={true}
				rootClassName="scrollableDiv_review"
				transitionName="custom-transition"
				forceRender={false}
				footer={null}>
				<ReviewDetail
					dataSource={showReviewDetail}
					defaultIndexSlide={defaultIndexSlide}
					visible={showReviewDetail.length > 0 ? true : false}
					// defaultImageItem={}
					navigation={false}></ReviewDetail>
			</Modal>
			<Modal
				key={"modal_delete"}
				title={
					<Typography.Title
						level={4}
						style={{
							fontSize: "24px",
							lineHeight: "29px",
							color: "#3A393A",
							margin: "0 0 8px 0",
							textAlign: "center",
						}}>
						Xóa {typeText}
					</Typography.Title>
				}
				open={confirmDeleteId > 0}
				onCancel={() => {
					setConfirmDeleteId(0);
				}}
				confirmLoading={loadingDelete}
				onOk={() => handleDeleteComment(confirmDeleteId)}
				cancelButtonProps={{ style: { flex: 1 } }}
				okButtonProps={{ style: { backgroundColor: "#D72229", flex: 1 } }}
				wrapClassName="modal_delete-qa"
				destroyOnClose={true}></Modal>
		</div>
	);
};

export default CommentItem;
